export interface generateImageLinkProps {
  imageId: string;
}

export const generateImageLink = ({ imageId }: generateImageLinkProps) => {
  if (imageId) {
    return `${process.env.REACT_APP_API_SERVER_URL}/storage/${imageId}`;
  } else return "";
};
